import { coreModule } from '@/src/features/core';
import type {
  PanelDef,
  SliceToolComponents,
  ToolbarPanelDef,
  ToolbarToolDef,
  ViewerModule,
  WorkspaceDef,
} from '@/src/features/types';
import { Tools } from '@/src/store/tools/types';

const modules: ViewerModule[] = [coreModule];

if (__FEATURE_ANNOTATIONS__) {
  const { annotationsModule } = await import('@/src/features/annotations');
  modules.push(annotationsModule);
}
if (__FEATURE_CROPPING__) {
  const { croppingModule } = await import('@/src/features/cropping');
  modules.push(croppingModule);
}
if (__FEATURE_IMPLANT_PLANNING__) {
  const { implantPlanningModule } =
    await import('@/src/features/implantPlanning');
  modules.push(implantPlanningModule);
}
if (__FEATURE_REMOTE_SERVER__) {
  const { remoteServerModule } = await import('@/src/features/remoteServer');
  modules.push(remoteServerModule);
}

export function getViewerModules(): ViewerModule[] {
  return modules;
}

export function enabledPanels(): PanelDef[] {
  return modules.flatMap((m) => m.panels ?? []);
}

export function enabledToolbarPanels(): ToolbarPanelDef[] {
  return modules.flatMap((m) => m.toolbarPanels ?? []);
}

export function enabledToolbarTools(): ToolbarToolDef[] {
  return modules.flatMap((m) => m.toolbarTools ?? []);
}

export function enabledWorkspaces(): WorkspaceDef[] {
  return modules.flatMap((m) => (m.workspace ? [m.workspace] : []));
}

export function enabledSliceTools(): SliceToolComponents {
  return modules.reduce<SliceToolComponents>((acc, mod) => {
    return { ...acc, ...(mod.sliceTools ?? {}) };
  }, {});
}

/** Tools that should auto-open a right-side panel when activated. */
export function getAutoOpenPanelForTool(tool: Tools): string | null {
  for (const mod of modules) {
    if (mod.autoOpenTools?.includes(tool) && mod.autoOpenPanelOnTool) {
      return mod.autoOpenPanelOnTool;
    }
  }
  return null;
}

export {
  isFeatureCompiled,
  isToolbarToolEnabled,
} from '@/src/features/featureFlags';
